import { render } from "./GuildNotAuthenticated.vue?vue&type=template&id=41bfae44"
import script from "./GuildNotAuthenticated.vue?vue&type=script&lang=js"
export * from "./GuildNotAuthenticated.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bewinxed/Downloads/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__